<template>
  <fullLayout>
    <div class="remote-page-shell">
      <tablePageHost
        ref="hostRef"
        :app_flag="field.app_flag"
        :modalType="field.modalType"
      ></tablePageHost>
    </div>
  </fullLayout>
</template>
<script setup lang="ts">
// 路由级薄壳：只负责「从路由解析 app_flag/modalType」与「required_condition 写入 store」
// 这两个页面级副作用；其余壳逻辑（总线/详情抽屉/视图模式/hash/keep-alive 注册）
// 全部参数化在 tablePageHost.vue 中，与 detailTablePro 共用同一份实现。
import fullLayout from 'liyu-pc-base/components/fullLayout/fullLayout.vue';
import tablePageHost from './tablePageHost.vue';
import { computed, ref, watch, onActivated } from 'vue';
import { useRoute } from 'vue-router';
import { useRequiredConditionStore } from 'liyu-pc-base/init-plugin';

const route = useRoute();
const requiredConditionStore = useRequiredConditionStore();
const path_arr = route.path.split('/');
const field = {
  app_flag: path_arr[path_arr.length - 2],
  modalType: path_arr[path_arr.length - 1],
};

const hostRef = ref(null);
// defineExpose 暴露的 ref 经模板引用访问时自动解包
const pageConfig = computed(() => hostRef.value?.pageConfig ?? null);

const syncRequiredCondition = () => {
  if (pageConfig.value?.required_condition) {
    requiredConditionStore.set_required_condition(
      field.modalType,
      pageConfig.value.required_condition,
    );
  }
};
watch(pageConfig, syncRequiredCondition);
onActivated(syncRequiredCondition);
</script>
<style scoped lang="less">
.remote-page-shell {
  height: 100%;
}
</style>
